import { render, staticRenderFns } from "./MPopupNoticeLogoData.vue?vue&type=template&id=01a089c8&"
import script from "./MPopupNoticeLogoData.vue?vue&type=script&lang=ts&"
export * from "./MPopupNoticeLogoData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports